import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: number;
  username: string;
  full_name: string;
  role: string;
  avatar?: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  sessionToken: string | null;
  refreshToken: string | null;
  expiresAt: string | null;
  isAuthenticated: boolean;
  login: (user: User, token: string, sessionToken: string, refreshToken: string, expiresAt: string) => void;
  logout: () => void;
  refreshAuth: (token: string, expiresAt: string) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      sessionToken: null,
      refreshToken: null,
      expiresAt: null,
      isAuthenticated: false,
      login: (user: User, token: string, sessionToken: string, refreshToken: string, expiresAt: string) =>
        set({
          user,
          token,
          sessionToken,
          refreshToken,
          expiresAt,
          isAuthenticated: true,
        }),
      logout: () =>
        set({
          user: null,
          token: null,
          sessionToken: null,
          refreshToken: null,
          expiresAt: null,
          isAuthenticated: false,
        }),
      refreshAuth: (token: string, expiresAt: string) =>
        set({
          token,
          expiresAt,
        }),
    }),
    {
      name: 'auth-storage',
    }
  )
); 